import * as React from 'react';
import curry from 'lodash/curry';

import { flip, pipe } from '../Utils/fp';
import pad from '../Utils/padNumber';
import ScreenReaderOnly from '../Accessibility/ScreenReaderOnlyStyles';

import { composableRenderDayFunction, renderDayFunction } from './common';

// @ts-ignore:next-line
export const leadingZero: composableRenderDayFunction = (day, _) => <>{pad(day as unknown as string)}</>;

export const dueCell: composableRenderDayFunction = (day, modifiers) => (
  <div>
    {day}
    {modifiers && modifiers.due && <div className='due-text'>DUE</div>}
  </div>
);

export const selectedDay: composableRenderDayFunction = (day, modifiers) => (
  <>
    {day}
    {modifiers && modifiers.selected && <ScreenReaderOnly>this day is selected</ScreenReaderOnly>}
  </>
);

export const makeRenderDay =
  (renderDayFns: composableRenderDayFunction[]): renderDayFunction =>
    (day, modifiers) => {
      const d = day.getDate();

      const curriedFns = renderDayFns.map(curry);

      const flipArgsAndPassMods = curriedFns.map(fn => flip(fn)(modifiers));

      return pipe(...flipArgsAndPassMods)(d);
    };
